import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { ParametroVisualizacaoRequestModel } from 'model/api/gestao/parametro/parametro-visualizacao-request-model';
import { ParametroVisualizacaoResponseModel } from 'model/api/gestao/parametro/parametro-visualizacao-response-model';

export function usePostParametroVisualizacao() {
  const { invocarApi, ...outrasPropriedades } =
    useApiBase<ParametroVisualizacaoResponseModel>();

  const postParametroVisualizacao = useCallback(
    (model: ParametroVisualizacaoRequestModel) =>
      invocarApi({
        method: 'POST',
        url: `/${VariaveisAmbiente.apiVersion}/parametro/visualizacao`,
        data: model,
        enviarTokenUsuario: true,
      }),
    [invocarApi],
  );
  return {
    ...outrasPropriedades,
    postParametroVisualizacao,
  };
}
